import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Row, Col } from 'antd';
import productsData from '../data/products.json';
import '../css/Product.css';

const Product = () => {
  const [activeId, setActiveId] = useState(null);
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: productsData.map((product, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Product',
        name: product.title,
        description: product.en
      }
    }))
  };

   // 沿用與 Header 相同的判斷邏輯 (中英文切換)
      const location = useLocation();
      const isEnglish = location.pathname.startsWith('/en');

  return (
    <section className="product-page">
      <Helmet>
        <title>五大餐飲原料產品</title>
        <meta name="description" content="湯武生技供應果醬糖漿、果凍粉、椰果蒟蒻等五大餐飲原物料，滿足全球餐飲品牌需求。" />
        <meta name="keywords" content="果醬糖漿, 果凍粉" />
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>
      <div className="intro-text-box">
        
        {isEnglish ? (
          <>
            <div className="big-title-en">Products</div>
          </>
        ) : (
          <>
              <div className="title-en mb-5">Products</div>
              <h1 className="big-title-ch">五大產品</h1>
          </>
        )}
      </div>

      {productsData.map((product) => {
        const isActive = activeId === product.id;
        return (
          <div
            key={product.id}
            className={`expand-entry-container ${isActive ? 'active' : ''}`}
            style={{
              backgroundImage: `url(${require(`../images/${product.imgName}`)})`
            }}
            onClick={() => setActiveId(isActive ? null : product.id)}
          >
            {/* 未展開標題 */}
            {!isActive && (
              <div className="banner-center-text">
                <h2 className="title-ch">{product.title}</h2>
                <p className="title-en">{product.en}</p>
              </div>
            )}

            {/* 展開後的內容 */}
            <div className={`expand-full-content ${isActive ? 'show' : ''}`}>
              <div className="content-inner" onClick={(e) => e.stopPropagation()}>
                <div className="expand-header-row">
                  <h2 className="title-ch">{product.title}</h2>
                  <p className="title-en">{product.en}</p>
                </div>

                {product.details.categories.map((cat, idx) => (
                  <div key={idx} className="product-category-group">
                    <Row gutter={[4, 4]} className="product-detail-grid">
                      {cat.items.map((item, i) => (
                        <Col xs={24} sm={12} md={12} lg={12} key={i}>
                          <div className="product-item-row">
                            <span className="product-item-ch">{item.ch}</span>
                            <span className="product-item-en">{item.en}</span>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Product;